<!--
 * @Descripttion: 使用条款
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 09:53:53
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 10:47:11
-->
<template>
  <div class="word use_clause p-t-120">
    <div class="container ui-common-list">
      <div>
        <div v-for="(item, index) in $t('useClause.des')" :key="index">{{item}}</div>
      </div>
      <div class="word-main">
        <div class="word-main-list" v-for="(item,index) in $t('useClause.list')" :key="index">
          <div class="title"><span v-html="item.title"></span><i class="line"></i></div>
          <div class="des" v-for="(list,i) in item.des" :key="i" v-html="list"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
